import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { registerLocaleData } from "@angular/common";
import localeNl from "@angular/common/locales/nl";
import localeFi from "@angular/common/locales/fi";
import localeSv from "@angular/common/locales/sv";
import localeNb from "@angular/common/locales/nb";
import localeEs from "@angular/common/locales/es";
import localeDe from "@angular/common/locales/de";
import localeEnGb from "@angular/common/locales/en-GB";

import { IAppInfo, LG_APP_CONFIGURATION, LG_APP_INFO } from "@logex/framework/lg-application";
import { LgLoaderService } from "@logex/framework/lg-layout";
import { AppConfiguration } from "@shared/services";
import { RouteConfigLoadEnd, RouteConfigLoadStart, Router } from "@angular/router";

@Component({
    selector: "app-root",
    template: `<router-outlet></router-outlet>`,
    changeDetection: ChangeDetectionStrategy.Default
})
export class AppComponent {
    constructor(
        @Inject(LG_APP_CONFIGURATION) public appConfiguration: AppConfiguration,
        @Inject(LG_APP_INFO) public appInfo: IAppInfo,
        private _router: Router,
        private _loaderService: LgLoaderService
    ) {
        registerLocaleData(localeNl);
        registerLocaleData(localeEnGb);
        registerLocaleData(localeNl);
        registerLocaleData(localeFi);
        registerLocaleData(localeSv);
        registerLocaleData(localeNb);
        registerLocaleData(localeDe);
        registerLocaleData(localeEs);

        this._router.events.subscribe(ev => {
            if (ev instanceof RouteConfigLoadStart) {
                this._loaderService.show();
            } else if (ev instanceof RouteConfigLoadEnd) {
                this._loaderService.hide();
            }
        });
    }
}
